import AxiosInstanceCreator from '../../../services/api';
import qs from 'qs';
import {
  ResEnvironmentNow,
  ResEnvironmentMetas,
  ResEnvironmentDaily,
  ResEnvironmentHistories
} from '../models/environment.model';

const environmentInstance = new AxiosInstanceCreator().create();

export const environmentApi = {
  async getNowEnvironment(): Promise<ResEnvironmentNow> {
    // 현재 기상 조회
    return environmentInstance.get('environment/now').then((res) => res.data);
  },

  async getNowEnvironments(): Promise<ResEnvironmentMetas> {
    // 기상 통계 조회
    return environmentInstance.get('environment/now/graph').then((res) => res.data);
  },

  async getDailyEnvironment(date: string): Promise<ResEnvironmentDaily> {
    // 일자별 기상 조회
    return environmentInstance.get(`environment/daily?date=${date}`).then((res) => res.data);
  },

  async getDailyEnvironments(date: string): Promise<ResEnvironmentMetas> {
    // 기상 통계 조회
    return environmentInstance.get(`/environment/daily/graph?from=${date}`).then((res) => res.data);
  },

  async getEnvironmentHistories(query: string): Promise<ResEnvironmentHistories> {
    return environmentInstance.get(`/environment/period?${query}`).then((res) => res.data);
  },

  async getEnvironmentExcel(data: any) {
    return environmentInstance
      .get(`/environment/excel/export/period?${qs.stringify(data)}`, {
        responseType: 'arraybuffer'
      })
      .then((res) => res.data);
  },

  async getLocalEnvironment() {
    // 사우디아라비아 현지 기상 조회
    // 사우디 아라비아 좌표 Al hasa
    // 링크 : https://openweathermap.org/current
    const lat = 24.1290482;
    const lng = 52.7963177;
    const key = import.meta.env.VITE_WEATHER_API_KEY;
    // todo : Axios 사용 시 CORS 에러
    return fetch(
      `https://api.openweathermap.org/data/2.5/weather?lat=${lat}&lon=${lng}&appid=${key}&units=metric`
    );
  },

  async getLocalAirPopullution() {
    // 사우디아라비아 현지 미세먼지
    // 사우디 아라비아 좌표 Al hasa
    // 링크 : https://openweathermap.org/current
    const lat = 24.1290482;
    const lng = 52.7963177;
    const key = import.meta.env.VITE_WEATHER_API_KEY;
    // todo : Axios 사용 시 CORS 에러
    return fetch(
      `https://api.openweathermap.org/data/2.5/air_pollution?lat=${lat}&lon=${lng}&appid=${key}`
    );
  }
};
